<ds-card
  class="pi-hero-card"
  [background]="heroBackground"
  shadow="l2"
  gap="32px">
  <div class="pi-hero">
    <div class="pi-hero__greeting">
      <h1 class="pi-hero__title">
        Solicitud de Pensión por<span class="pi-hero__title-br" aria-hidden="true"></span>Invalidez
      </h1>

      <p class="pi-hero__description">
        Estás por presentar tu solicitud de trámite de pensión por Invalidez,<br />
        solo debes seguir los pasos para completar el formulario.
      </p>

      <ds-button-v2
        class="pi-hero__info-btn"
        label="¿Qué es la Pensión por Invalidez?"
        emphasis="terciary"
        [invert]="true"
        size="s"
        (clicked)="queEsPension.emit()">
      </ds-button-v2>
    </div>

    <div class="pi-hero__panel">
      <div class="pi-hero__panel-meta">
        <div class="pi-hero__panel-item">
          <p class="pi-hero__panel-label">Estado de la solicitud</p>
          <ds-tag-pill
            class="pi-hero__status-badge"
            label="Sin iniciar"
            variant="neutral"
            size="xs">
          </ds-tag-pill>
        </div>

        <div class="pi-hero__panel-divider" aria-hidden="true"></div>

        <div class="pi-hero__panel-item">
          <p class="pi-hero__panel-label">Duración</p>
          <p class="pi-hero__panel-value">
            <ds-icon name="Schedule" size="17px" aria-hidden="true"></ds-icon>
            20 minutos
          </p>
        </div>
      </div>

      <ds-button-v2
        class="pi-hero__steps-btn"
        label="Revisa los pasos"
        emphasis="secondary"
        [invert]="true"
        size="s"
        leadingIcon="PlayCircle"
        (clicked)="revisaPasos.emit()">
      </ds-button-v2>
    </div>
  </div>
</ds-card>
